import './note-tag.scss';

export enum NoteTagType {
  CREATOR = 'creator',
  EDITOR = 'editor',
}

type NoteTagProps = {
  type?: NoteTagType;
  text?: string;
};

export function NoteTag({ text, type }: NoteTagProps) {
  return (
    <span title={text ?? ''} className={`note-tag note-tag--${type}`}>
      {text}
    </span>
  );
}
